import { render, staticRenderFns } from "./btn-secondary3.vue?vue&type=template&id=4c90ed63&scoped=true&"
import script from "./btn-secondary3.vue?vue&type=script&lang=js&"
export * from "./btn-secondary3.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c90ed63",
  null
  
)

export default component.exports